import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../lib/axiosInstance';
import { AxiosError } from 'axios';
import { AppErrorResponse } from '../types';
import React from 'react';

export function useDeletePRFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await axiosInstance.delete(`/pr/requests/files?ids=${id}`);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useUploadPRFiles<T>() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: {
      id: string | null | undefined;
      formData: FormData;
    }) => {
      return await axiosInstance.putForm<T, AxiosError<AppErrorResponse>>(
        `/pr/requests/${data.id}/upload`,
        data.formData,
      );
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useGeneratePurchaseOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (prDetails: React.Key[]) => {
      return await axiosInstance.post(`/pr/requests/generatePO`, prDetails);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}
